<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" clearable :placeholder="`${$t('menu.ClaimNumber')}/${$t('menu.FrameNumber')}`"
          v-model="formInline.title"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formInline.claimType" :placeholder="$t('menu.ClaimType')" clearable>
          <el-option :label="$t('menu.All')" value=""></el-option>
          <el-option :label="iszh == 'zh' ?  item.dictLabel : item.dictLabelEn" :value="item.dictValue" v-for="(item,index) in titleList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      
      <!-- <el-form-item>
        <el-select v-model="formInline.orderType" :placeholder="$t('menu.VehicleModel')" clearable>
          <el-option :label="$t('menu.All')" value=" "></el-option>
          <el-option v-for="(item, index) in list" :key="index" :label="iszh == 'zh' ? item.seriesModel:item.seriesModelEn" :value="item.id" v-if="item.id != 9000"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-select v-model="formInline.mcSeriesModelId" :placeholder="$t('menu.VehicleModel')" clearable>
          <el-option :label="$t('menu.All')" value=" "></el-option>
          <el-option v-for="(item, index) in list" :key="index" :label="iszh == 'zh' ? item.seriesModel:item.seriesModelEn" :value="item.id" v-if="item.id != 9000"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="tup!=='2'">
        <el-select v-model="formInline.dealerAreaId" :placeholder="$t('menu.Country')" clearable>
          <el-option :label="$t('menu.All')" value=" "></el-option>
          <el-option v-for="(item, index) in gb" :key="index" :label="iszh == 'zh' ? item.dictLabel:item.dictLabelEn" :value="item.dictValue" ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item>
        <el-select v-model="formInline.status" :placeholder="$t('menu.State')" clearable>
          <el-option :label='item.name' :value='item.id' v-for="(item,index) in staue" :key="index"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-date-picker v-model="formInline.startTime" type="date" value-format="yyyy-MM-dd" :placeholder="$t('menu.Expected')">
        </el-date-picker>
        -
        <el-date-picker v-model="formInline.endTime" type="date" value-format="yyyy-MM-dd" :placeholder="$t('menu.Expected')">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
        <el-button @click="reset">{{ $t('menu.Reset') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="bonntbot">
      <div style="display: flex;">
        <div style="cursor: pointer;margin-right: 25px;" v-for="(item, index) in staue" :key="index" @click="tabclick(index,item)"
          :class="action == index ? 'actio' : ''">
          <span>{{ item.name }}</span><span v-if="item.num>0">({{ item.num }})</span>
        </div>
      </div>
      <div>
        <el-button  v-if="tup!=='2'" type="text" @click="ExportOrder">{{ $t('menu.ExportOrder') }}</el-button>
        <el-button  v-if="tup!=='2'" type="text" @click="exportMyCoDetails">{{ $t('menu.ExportDetails') }}</el-button>
      </div>
    </div>
    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row :row-key="getRowKeys"  @selection-change="handleSelectionChange">
      <!-- <el-table-column
        v-if="tup!=='2'"
      type="selection"
    
      :reserve-selection="true"
      width="55">
    </el-table-column> -->
      <el-table-column :label="$t('menu.OrderNumber')" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.claimNumber }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('menu.FrameNo')" min-width="160">
        <template slot-scope="scope">
          {{ iszh == 'zh' ? scope.row.motorName : scope.row.motorNameEn }} <br />
    
        </template>
      </el-table-column>
      <el-table-column :label="$t('menu.FrameNumber')" min-width="180">
        <template slot-scope="scope">
         
          {{ scope.row.vin }}
        </template>
      </el-table-column>
      <el-table-column  :label="$t('menu.ClaimType')" min-width="120">
        <template slot-scope="scope" v-if="scope.row.claimType!==null">
          {{ iszh == 'zh' ? titleList.filter(e =>e.dictValue == scope.row.claimType)[0].dictLabel : titleList.filter(e =>e.dictValue == scope.row.claimType)[0].dictLabelEn }}
        </template>
      </el-table-column>

      <el-table-column  v-if="tup!=='2'" :label="$t('menu.Country')" min-width="100">
        <template slot-scope="scope">
          {{ gbls(scope.row.applyingDealerAreaId)}}
        </template>
      </el-table-column>

      <el-table-column :label="$t('menu.Currency')" min-width="80">
        <template slot-scope="scope">{{ currency }}</template>
      </el-table-column>
      <el-table-column :label="$t('menu.ClaimAmount')" min-width="80">
        <template slot-scope="scope">
          {{ scope.row.claimAmount }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('menu.State')" min-width="100">
        <template slot-scope="scope">
          {{ stauea.filter(e=>e.id == scope.row.status).length>0?stauea.filter(e=>e.id == scope.row.status)[0].name:scope.row.status  }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('menu.ApplicationTime')" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.applicationTime.slice(0, 10) }}{{ " " }}{{ scope.row.applicationTime.slice(11, 19) }}
        </template>

      </el-table-column>
      <el-table-column>
        <template slot="header" slot-scope="scope" min-width="120">
          <div>{{ $t('menu.Operation') }}</div>
        </template>
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleEdit(2, scope.row)">{{ $t('menu.Details') }}</el-button>

        </template>
      </el-table-column>
    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total,sizes, prev, pager, next"
        :total="totale">
      </el-pagination>
    </div>

    <div></div>
  </div>
</template>

<script>
import { pageQueryMyCo, listMcSeriesModels,gbquerytype, infostatus,getInfo,pageMySumCo,querytype,exportMyCo,exportMyCoDetails,listAccType } from "../../api/api";

export default {
  data () {
    return {
      activeName: 0,
      iszh:sessionStorage.getItem('i18n'),
      titleList:[],
      currency:sessionStorage.getItem('shbz'), //币种
      staue: [
      {
          name: this.$t('menu.All'),
          num: 0,
          id: ''
        },
        {
          name: this.$t('menu.PendingReview'),
          num: 0,
          id: 10
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '20,29,30,31,39,40,49'
        },
        {
          name: this.$t('menu.pfzl'),
          num: 0,
          id: '50'
        },
         {
          name: this.$t('menu.ypfl'),
          num: 0,
          id: '55'
        },
         {
          name: this.$t('menu.dkhqrl'),
          num: 0,
          id: '59'
        },
        {
          name: this.$t('menu.Cancelled'),
          num: 0,
          id: '60'
        },
      ],
      stauea: [
      {
          name: this.$t('menu.All'),
          num: 0,
          id: ''
        },
        {
          name:  this.$t('menu.PendingReview'),
          num: 0,
          id: 10
        },
        
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '20'
        },
        {
          name:this.$t('menu.Underreview'),
          num: 0,
          id: '29'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '30'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '31'
        },
        {
          name:this.$t('menu.Underreview'),
          num: 0,
          id: '39'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '40'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '49'
        },
        {
          name: this.$t('menu.pfzl'),
          num: 0,
          id: '50'
        },
         {
          name: this.$t('menu.ypfl'),
          num: 0,
          id: '55'
        },
         {
          name: this.$t('menu.dkhqrl'),
          num: 0,
          id: '59'
        },
        {
          name: this.$t('menu.Cancelled'),
          num: 0,
          id: '60'
        },
      ],
      list: [],
      tup:1,
      action: 0,
      activeName: '0',
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
      activeName: "first",
      mation: [], //列表
      formInline: {
        title: "",
        startTime: "",
        endTime: "",
        mcSeriesModelId: '',
        contact: "",
        status: '',
        category: "",
        claimType: '',
        type: "",
        dealerAreaId:'',
        orderType:''
      },
      acclist:[],
      uesrid:'',
      gb:[],
      multipleSelection:[],
    };
  },


  mounted () {
    this.listMcSeriesModel()
    this.biao();
    this.pageMySumCo()
    this.getQuerytype()
    this.acc()
    this.infoaa()
    this.getInfoa()
  },
  methods: {
    getRowKeys(row) {
      return row.id
    },
    handleSelectionChange(val) {
      console.log(val);
      
        this.multipleSelection = val;
      },
    gbls (data) {
       let that=this
        let value = ''
        let a =that.gb 
       
        let cc = sessionStorage.getItem('i18n')
        if(data!==''){
          a.forEach(e=>{
            if(e.dictValue==data){
             if(cc=='zh'){
              value=e.dictLabel
             }else{
              value=e.dictLabelEn
             }
            }
          })
        }
        return value;
      },
    async acc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
    this.acclist  = res.data
   

    },
    getInfoa () {
      getInfo().then(r => {
        if (r.data.code == 200) {
      
          this.uesrid = r.data.user.dealers[0].id
          this.gbquerytype()
        }
      })
    },
     //账户 
     async gbquerytype () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer_area/%20/', this.uesrid);
      this.gb = res.data
    },
    async infoaa () {
      let param = new URLSearchParams();
      const { data: res } = await getInfo(param)
      
       console.log(123123123, res.uesr);
      this.acclist.forEach(e => {
        if (e.id == res.user.dealers[0].accTypeIdLs&&res.uesr.platform=='2') {
          
          sessionStorage.setItem("shbz", e.currencyType)
   

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
         if (e.id == res.user.dealers[0].accTypeIdSh&&res.uesr.platform!=='2') {
          
            
          sessionStorage.setItem("shbz", e.currencyType)
   

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
      })
    },
    ExportOrder(){
      
      let param = 'endTime=' + this.formInline.endTime + '&mcSeriesModelId=' + this.formInline.mcSeriesModelId + '&claimType=' + this.formInline.claimType
        + '&startApplicationTime=' + this.formInline.startTime + '&status=' + this.formInline.status + '&vin=' + this.formInline.title
      
      exportMyCo(param).then(res => {
        // const link = document.createElement('a')
        // let blob = new Blob([res.data], { type: 'application/x-www-form-urlencoded' })
        // link.style.display = 'none'
        // link.href = URL.createObjectURL(blob)
        // link.setAttribute('download', '我的采购订单.xlsx')
        // document.body.appendChild(link)
        // link.click() //触发下载
        // document.body.removeChild(link)
        // 创建一个URL对象，将Blob对象包装成一个临时的可访问URL
        const url = window.URL.createObjectURL(new Blob([res.data]));
        // 创建一个<a>元素，用于模拟点击下载文件
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件的名称
        link.setAttribute('download', '我的索赔订单.xlsx');
        // 将<a>元素添加到文档中
        document.body.appendChild(link);
        // 模拟点击下载
        link.click();
        // 移除<a>元素
        // link.remove();
        // 释放创建的URL对象，避免内存泄漏
        window.URL.revokeObjectURL(url);
      })
    },
    exportMyCoDetails(){
      
      let param = 'endTime=' + this.formInline.endTime + '&mcSeriesModelId=' + this.formInline.mcSeriesModelId + '&claimType=' + this.formInline.claimType
        + '&startApplicationTime=' + this.formInline.startTime + '&status=' + this.formInline.status + '&vin=' + this.formInline.title
      
        exportMyCoDetails(param).then(res => {
        // const link = document.createElement('a')
        // let blob = new Blob([res.data], { type: 'application/x-www-form-urlencoded' })
        // link.style.display = 'none'
        // link.href = URL.createObjectURL(blob)
        // link.setAttribute('download', '我的采购订单.xlsx')
        // document.body.appendChild(link)
        // link.click() //触发下载
        // document.body.removeChild(link)
        // 创建一个URL对象，将Blob对象包装成一个临时的可访问URL
        const url = window.URL.createObjectURL(new Blob([res.data]));
        // 创建一个<a>元素，用于模拟点击下载文件
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件的名称
        link.setAttribute('download', '索赔明细.xlsx');
        // 将<a>元素添加到文档中
        document.body.appendChild(link);
        // 模拟点击下载
        link.click();
        // 移除<a>元素
        // link.remove();
        // 释放创建的URL对象，避免内存泄漏
        window.URL.revokeObjectURL(url);
      })
    },
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();

      const { data: res } = await listMcSeriesModels(param);

      this.list = res.data;
      // this.formInline.mcSeriesModelId = this.mcSeriesModelId/

    },
    pageMySumCo(){
      let param = 'endTime=' + this.formInline.endTime + '&mcSeriesModelId=' + this.formInline.mcSeriesModelId + '&claimType=' + this.formInline.claimType
        + '&startApplicationTime=' + this.formInline.startTime + '&status=' + this.formInline.status + '&vin=' + this.formInline.title
      pageMySumCo(param).then(res=>{
        res.data.data.forEach(e => {
          this.staue.forEach(m=>{
            if(m.id == e.status){
              m.num = e.sum
            }
            if(m.name==this.$t('menu.Underreview')){
             
              if( e.status=='20'||e.status=='29'||e.status=='30'||e.status=='31'||e.status=='39'||e.status=='40'||e.status=='49' ){
                m.num =  m.num + e.sum
             }
            }
          })
        });
      })
    },
    async biao () {
      let param = new URLSearchParams();
     
      let asta1 = this.formInline.startTime?this.formInline.startTime.slice(0,4):this.formInline.startTime
      let asta2 = this.formInline.endTime?this.formInline.endTime.slice(0,4):this.formInline.endTime
       console.log(this.formInline.startTime);
       
      if(this.formInline.startTime !==''&&this.formInline.startTime !==null&&this.formInline.startTime.length<12){
        this.formInline.startTime = this.formInline.startTime + ' 00:00:00'
        
      }
      if(asta1  ==null){
        this.formInline.startTime =''
        
      }
      if(this.formInline.endTime !==''&&this.formInline.endTime !==null&&this.formInline.endTime.length<12){
        this.formInline.endTime = this.formInline.endTime + ' 00:00:00'
        
      }
      if(asta2 ==null){
        this.formInline.endTime =''
        
      }
      this.tup=sessionStorage.getItem('platform')
      const { data: res } = await pageQueryMyCo(
        param,
        this.currentPage3,
        this.pagesize,
        this.formInline.mcSeriesModelId,
        this.formInline.title,
        this.formInline.status,
        this.formInline.claimType,
        this.formInline.startTime,
        this.formInline.endTime,
        this.formInline.dealerAreaId
      );
      this.mation = res.data.list;
      this.totale = res.data.total;
    },
    //表单点击
    handleEdit (index, row) {
      let a = sessionStorage.getItem('name')
      let b = sessionStorage.getItem('namef')
      sessionStorage.setItem('namefac1',a )
      sessionStorage.setItem('namefac2',b )
      console.log(11111111122222222,this.inle);
      let cc  =sessionStorage.getItem('i18n')
      if (cc == 'zh') {
        sessionStorage.setItem('name', '订单详情')
        sessionStorage.setItem('namef', 'Details')

      } else {
        sessionStorage.setItem('name', 'Details')
        sessionStorage.setItem('namef', '订单详情')
      }
      if(this.tup=='2'){
 this.$router.push({
        path: "/ClaimApplyc",
        query: {
          id: row.id,
          type: index,
        },
      });
      }else{
         this.$router.push({
        path: "/ClaimApply",
        query: {
          id: row.id,
          type: index,
        },
      });
      }
     
    },
    //tab切换
    tabclick (i,item) {
      this.action=i
      this.formInline.status = item.id
      this.biao()
    },

    //搜索
    onSubmit () {
      this.biao();
    },
    reset(){
      this.formInline= {
     
          title: "",
        startTime: "",
        endTime: "",
        mcSeriesModelId: '',
        contact: "",
        status: '',
        category: "",
        claimType: '',
        type: "",
        dealerAreaId:'',
        orderType:''
      },
      this.biao();
    },

    handleSizeChange (val) {
      this.pagesize = val
      this.biao();
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.biao();
    },
    getQuerytype () {
      const params = new URLSearchParams()
      querytype( params, 't_co_claim_type').then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
            if (this.iszh !== 'zh') {
              i.dictLabel = i.dictLabelEn
            }
            this.titleList.push(i)
          })
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.blueColor{
  color: red;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 20px;
  border-bottom: 1px solid #d7d7d7;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
}
</style>